<template>
  <el-container>
    <div class="zhezhao" :class="menuOpen" @click="toggle"></div>
    <el-row class="tac" :class="menuOpen">
      <el-col :span="24">
        <el-menu
          :router="true"
          :default-active="this.$route.path"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          background-color="rgb(48, 65, 86)"
          text-color="rgb(191, 203, 217)"
          active-text-color="rgb(64, 158, 255)"
        >
          <el-menu-item index="/home">
            <i class="el-icon-menu"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <template v-for="x in navdata">
            <template v-if="x.children">
              <el-submenu :index="x.directory" :key="x.id">
                <template slot="title">
                  <i :class="x.icon"></i>
                  <span>{{ x.title }}</span>
                </template>
                <template v-for="y in x.children">
                  <template v-if="y.children">
                    <el-submenu :index="y.directory" :key="y.id">
                      <template slot="title">
                        <span>{{ y.title }}</span>
                      </template>
                      <template v-for="s in y.children">
                        <el-menu-item
                          :index="
                            '/' +
                            x.directory +
                            '/' +
                            y.directory +
                            (!!s.directory ? '/' + s.directory : '') +
                            '/' +
                            s.path
                          "
                          :title="
                            '/' +
                            x.directory +
                            '/' +
                            y.directory +
                            (!!s.directory ? '/' + s.directory : '') +
                            '/' +
                            s.path
                          "
                          :key="s.id"
                          >{{ s.title }}</el-menu-item
                        >
                      </template>
                    </el-submenu>
                  </template>
                  <el-menu-item
                    v-else
                    :index="
                      '/' +
                      x.directory +
                      (!!y.directory ? '/' + y.directory : '') +
                      '/' +
                      y.path
                    "
                    :title="
                      '/' +
                      x.directory +
                      (!!y.directory ? '/' + y.directory : '') +
                      '/' +
                      y.path
                    "
                    :key="y.id"
                    >{{ y.title }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
          </template>
        </el-menu>
      </el-col>
    </el-row>

    <el-container id="Contents" :class="menuOpen">
      <el-header>
        <el-row>
          <el-col :span="19">
            <i class="el-icon-s-fold" @click="toggle"></i>
            <Breadcrumb></Breadcrumb>
          </el-col>
          <el-col :span="5">
            <el-dropdown>
              <span class="el-dropdown-link">
                {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>首页</el-dropdown-item>
                <el-dropdown-item divided @click.native="loginout"
                  >退出登陆</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  data() {
    return {
      name: "Layout",
      isCollapse: false,
      menuOpen: "open",
      name: localStorage["name"],
      navdata: [],
    };
  },
  methods: {
    toggle() {
      if (this.isCollapse) {
        this.isCollapse = false;
        this.menuOpen = "open";
      } else {
        this.isCollapse = true;
        this.menuOpen = "close";
      }
    },
    async loginout() {
      this.$http.post("/manage/logout").then((results) => {
        this.$store.commit("loginOut");
        this.$router.push("/login");
      });
    },
    navigat(data) {
      let resData = data;
      let tree = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i]["pid"] === 0) {
          resData[i]["children"] = [];
          tree.push(resData[i]);
          resData.splice(i, 1);
          i--;
        }
      }
      run(tree);

      function run(chiArr) {
        if (resData.length !== 0) {
          for (let i = 0; i < chiArr.length; i++) {
            for (let j = 0; j < resData.length; j++) {
              if (chiArr[i].id === resData[j]["pid"]) {
                
                const obj = {
                  children: [],
                  ...resData[j]
                }
                chiArr[i].children.push(obj);
                resData.splice(j, 1);
                j--;
              }
            }
            run(chiArr[i].children);
          }
        }
      }
      tree.map((i) => {
        if (i.id !== 9) {
          return i.children.map((s) => {
            if(s.id !== 81) {
              delete s.children;
            }
            return s;
          });
        }
        return i;
      });
      return tree;
    },
  },
  created: function () {
    if (window.screen.width < 736) {
      this.isCollapse = true;
      this.menuOpen = "close";
    }
    this.navdata = this.navigat(JSON.parse(localStorage["navigat"]));
  },
  components: { Breadcrumb },
};
</script>

<style lang="scss">
li {
  list-style: none;
}
.tac {
  position: fixed !important;
  z-index: 999;
  overflow-y: auto;
  height: 100%;
}
.el-menu {
  border: none !important;
  text-align: left;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  height: 100%;
  width: 200px;
  min-height: 100vh;
}

.el-menu-vertical-demo.el-menu--collapse {
  min-height: 100vh;
}

.el-menu .el-menu-item:hover,
.el-menu li div:hover {
  background-color: rgb(38, 52, 69) !important;
}

.el-submenu .el-menu-item {
  background-color: #1f2d3d !important;
}

.el-submenu .el-menu-item:hover {
  background-color: #001528 !important;
}

#Contents {
  transition: margin-left 0.3s;
  -moz-transition: margin-left 0.3s;
  /* Firefox 4 */
  -webkit-transition: margin-left 0.3s;
  /* Safari 和 Chrome */
  -o-transition: margin-left 0.3s;

  /* Opera */
  &.open {
    margin-left: 200px;
  }

  &.close {
    margin-left: 64px;
  }
}

.el-header,
.el-header .el-breadcrumb {
  line-height: 60px;
  vertical-align: middle;
  text-align: left;
}

.el-header i:first-child {
  font-size: 22px;
  position: relative;
  top: 0.1rem;
}

.el-header .el-breadcrumb {
  margin-left: 15px;
}

.el-dropdown {
  float: right;
}

.el-header .el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-header .el-icon-arrow-down {
  font-size: 12px;
}

.tableDel-Page {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
}
.tableDel-Page .delete {
  flex: 1;
}
.tableDel-Page .el-pagination {
  flex: 1;
  margin-top: 0px;
  text-align: right;
}
.el-main {
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
}

@media screen and (max-width: 736px) {
  .tac.open {
    left: 0px;
  }

  .tac.close {
    left: -64px;
  }

  #Contents.open,
  #Contents.close {
    margin-left: 0px;
  }

  .zhezhao.open {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: fixed;
    z-index: 999;
  }
}
</style>
